module.exports = __webpack_public_path__ + "static/media/Lisa Seaman.b9d9188b.jpg";